module.exports = __webpack_public_path__ + "img/nauru.4c394b6f.svg";